module.exports = __webpack_public_path__ + "static/media/menu.79b18a5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu.png
// module id = 88
// module chunks = 0